// extracted by mini-css-extract-plugin
export default {"container":"_4zTpszQaAlJ32bxYFdAeCw==","content":"C7t8hsRTfFVd44aBkc7TEg=="};